import { sendGet } from './generic';
import IResult from '../../models/result/IResult';
import { getAnalyticsApiUrl } from '../../constants/Urls';
import CallStatistics from '../../models/customAssistant/CallStatistics';
import TopIntents from '../../models/customAssistant/TopIntents';

export const getCallStatistics = (organizationId: string, startDate: string, endDate: string): Promise<IResult<CallStatistics>> => {
    return sendGet<CallStatistics>(`/v2/Organization/${organizationId}/callStatistics?startDate=${startDate}&endDate=${endDate}`, getAnalyticsApiUrl());
}

export const getTopIntents = (organizationId: string, startDate: string, endDate: string): Promise<IResult<TopIntents[]>> => {
    return sendGet<TopIntents[]>(`/v2/Organization/${organizationId}/topIntents?startDate=${startDate}&endDate=${endDate}`, getAnalyticsApiUrl());
}
